import API from '../index';
import { Order } from '../../types/common';

const voidPickup = async (orderId: string): Promise<Order> => {
  const data: Order = await API.delete(`/orders/${orderId}/pickup`);
  return data;
};

export default voidPickup;
